<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="400000" />
    <section slot="titleRight">
      <qx-permpisions permpisions="4000301">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'loginAcct'">
                  <span class="primary cur" @click="toDetail(scope.row)">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'productNum'">
                  <span
                    v-if="
                      scope.row.serviceType === 1 || scope.row.serviceType === 2
                    "
                  >
                    <span
                      class="primary cur"
                      @click="toSelfSite(scope.row)"
                      style="margin-right: 6px"
                      >{{ scope.row[scope.column.property] }}</span
                    >
                    <template v-if="checkPermpisions('4000305')">
                      <span
                        class="primary cur"
                        @click="toAddSelfSite(scope.row)"
                        >新增</span
                      >
                    </template>
                  </span>
                  <span v-else>-</span>
                </section>
                <section v-else-if="scope.column.property === 'bindTypeName'">
                  <template v-if="checkPermpisions('4000309')">
                    <span class="primary cur" @click="toBankcard(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                  </template>
                  <template v-else>{{
                    scope.row[scope.column.property]
                  }}</template>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '4000303',
                    showCondition: scope.row.hasVer === 0,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '',
                    showCondition: scope.row.invitationStateName === '处理中',
                    name: '确认',
                    event: () => toConfirm(scope.row),
                  },
                  {
                    permpisions: '4000302',
                    showCondition:
                      scope.row.invitationState !== 1 &&
                      scope.row.invitationState !== 3,
                    name: '修改',
                    event: () => toEdit(scope.row.serviceUserId),
                  },
                  {
                    permpisions: '4000304',
                    showCondition: scope.row.state === 0,
                    name: '删除',
                    event: () => del(scope.serviceUserId),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.relId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  servicerList,
  servicerDel, serviceConfirm,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'loginAcct', label: '服务商账号', fixed: true },
          { prop: 'serviceName', label: '服务商名称' },
          { prop: 'companyAddress', label: '公司地址' },
          { prop: 'linkman', label: '联系人' },
          { prop: 'serviceTypeName', label: '服务商类型' },
          { prop: 'productNum', label: '合作产品' },
          { prop: 'stateName', label: '账号状态' },
          { prop: 'authStateName', label: '认证状态' },
          // 暂时屏蔽支付相关的操作
          // {
          //   prop: 'bindTypeName',
          //   label: '银行卡',
          // },
          { prop: 'invitationStateName', label: '服务商审核状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: servicerList,
    toBankcard (item) {
      this.jump({
        label: '银行卡信息',
        url: `/manage/other/bankcard?userId=${item.serviceUserId}`,
        full: true,
      });
    },
    toSelfSite (item) {
      const { serviceUserId, serviceType, serviceName } = item;
      if (serviceType === 1 || serviceType === 2 || serviceType === 100 || serviceType === 3) {
        // 这四种有新增功能，而且新增的表单页面部分字段会不一样
        this.jump({
          label: `自有服务站点-${serviceName}`,
          url: `/manage/service/merchant/manage/cooperativeProducts?serviceUserId=${serviceUserId}&serviceType=${serviceType}&serviceName=${serviceName}`,
          full: true,
        });
      } else if (serviceType === 4) {
        this.$message({
          type: 'warning',
          message: '违章代缴服务商目前没有产品功能！',
        });
      } else if (serviceType === 5) {
        this.$message({
          type: 'warning',
          message: '保险服务商目前没有产品功能！',
        });
      } else if (serviceType === 6) {
        this.$message({
          type: 'warning',
          message: '年审服务商目前没有产品功能！',
        });
      } else {
        this.$message({
          type: 'warning',
          message: '该服务商目前没有产品功能！',
        });
      }
    },
    toAddSelfSite (item) {
      this.jump({
        label: '新增后服产品',
        url: `/manage/service/site/self/edit?serviceUserId=${item.serviceUserId}&serviceType=${item.serviceType || ''}`,
        full: true,
      });
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核服务商' : '服务商详情',
        url: `/manage/service/merchant/manage/detail?id=${item.serviceUserId}&relId=${item.relId}&type=${type}`,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '服务商',
        url: `/manage/service/merchant/manage/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    async del (serviceUserId) {
      const confirmRes = await this.$confirm('确认移除该服务商？移除后您将无法使用该服务商的产品，可在历史档案中查询。注：若该服务商名下有合作的后服产品，将会被一起移除进入历史档案。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await servicerDel({
          serviceUserId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    async toConfirm (item) {
      const confirmRes = await this.$confirm('是否确认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消核销
        this.$message({
          type: 'info',
          message: '已取消确认',
        });
      });
      let state = '';
      if (item.invitationStateName === '处理中') {
        state = 2;
      } else if (item.invitationStateName === '已通过') {
        state = 1;
      } else {
        state = 3;
      }
      if (confirmRes === 'confirm') {
        const res = await serviceConfirm({
          serviceUserId: item.serviceUserId,
          invitationState: state !== '' ? state : 2,
        });
        if (!res.failed) {
          this.$message.success('确认成功');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
